<script>
	import { page } from '$app/stores';
	import { cart } from '$lib/cart';
	import { cubicOut } from 'svelte/easing';
	import { fade, scale } from 'svelte/transition';
	import Currency from '$lib/components/currency.svelte';
	import * as DropdownMenu from '$lib/components/ui/dropdown-menu';
	import { MenuIcon } from 'lucide-svelte';

	let open = false;

	$: quantity = $cart.reduce((total, prev) => (total += prev.quantity), 0);
</script>

<header
	class="bg-background bg-opacity-50 backdrop-blur-md sticky top-0 left-o right-0 z-20 border-b border-b-gray-200"
>
	<nav class="max-w-screen-lg flex flex-row items-center justify-between mx-auto px-4 h-[52px]">
		<a href="/" title="Home" aria-label="Home">
			<img
				src="/logo.png"
				width="100"
				height="27"
				alt="Carnival Tyccon Cards Marketplace logo"
			/>
		</a>

		<div class="flex flex-row items-center gap-3">
			<Currency />

			<a href="/cart" aria-label="Shopping Cart">
				<div
					class="btn px-3 text-base h-[36px] max-h-[36px] font-semibold font-mono"
					class:btn-ghost={!$page.url.pathname.includes('cart')}
					class:btn-primary={$page.url.pathname.includes('cart')}
				>
					{#key quantity}
						<span
							class="flex flex-row items-center justify-center gap-1.5 text-lg leading-none"
							in:scale={{ start: 1.2, duration: 700, opacity: 0.5, easing: cubicOut }}
						>
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
								<path
									fill="currentColor"
									d="M6.505 2h11a1 1 0 0 1 .8.4l2.7 3.6v15a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V6l2.7-3.6a1 1 0 0 1 .8-.4m12 4l-1.5-2h-10l-1.5 2zm-9.5 4h-2v2a5 5 0 0 0 10 0v-2h-2v2a3 3 0 0 1-6 0z"
								/>
							</svg>
							<span class="mt-0.5">{quantity}</span>
						</span>
					{/key}
				</div>
			</a>

			{#if open}
				<div
					transition:fade={{ duration: 150 }}
					class="absolute bg-foreground bg-opacity-50 inset-0 min-w-screen min-h-screen"
				/>
			{/if}

			<DropdownMenu.Root bind:open>
				<DropdownMenu.Trigger>
					<MenuIcon size={32} strokeWidth={2} color="#404040" />
				</DropdownMenu.Trigger>
				<DropdownMenu.Content side="bottom" align="end" sideOffset={10}>
					<DropdownMenu.Item class="text-lg font-medium" href="/">
						<img
							src="/flash.png"
							width="20px"
							height="20px"
							alt="Flash retro icon"
							class="-mb-0.5"
						/>
						<span class="ml-2">Home</span>
					</DropdownMenu.Item>
					<DropdownMenu.Item class="text-lg font-medium" href="/orders">
						<img src="/star.png" width="22px" height="22px" alt="Star retro icon" />
						<span class="ml-2">Orders</span>
					</DropdownMenu.Item>
					<DropdownMenu.Item class="text-lg font-medium" href="/blog">
						<img src="/globe.png" width="22px" height="22px" alt="Globe retro icon" />
						<span class="ml-2">Blog</span>
					</DropdownMenu.Item>
					<DropdownMenu.Item class="text-lg font-medium" href="/help">
						<img src="/chat.png" width="22px" height="22px" alt="Chat bubble retro icon" />
						<span class="ml-2">Help Center</span>
					</DropdownMenu.Item>
				</DropdownMenu.Content>
			</DropdownMenu.Root>
		</div>
	</nav>
</header>
